// -- Model Predictive Control -- Control Systems ------------------------------------

const S = {
  wrapper:      { marginTop:'10px', padding:'40px', border:'3px solid grey', fontFamily:"'Georgia', serif", color:'#1a1a2e', lineHeight:'1.7' },
  h1:           { fontSize:'2rem', fontWeight:'700', borderBottom:'3px solid #c0392b', paddingBottom:'8px', marginBottom:'24px', color:'#7B0D0D' },
  h2:           { fontSize:'1.3rem', fontWeight:'700', color:'#c0392b', marginTop:'36px', marginBottom:'12px', borderLeft:'4px solid #c0392b', paddingLeft:'10px' },
  p:            { marginBottom:'12px', fontSize:'0.97rem' },
  infoBox:      { background:'#FEF0F0', border:'2px solid #c0392b', borderRadius:'6px', padding:'16px 20px', margin:'16px 0' },
  infoBoxTitle: { fontWeight:'700', fontFamily:"'Courier New', monospace", fontSize:'0.88rem', color:'#7B0D0D', marginBottom:'8px' },
  infoBoxItem:  { fontSize:'0.9rem', margin:'4px 0', paddingLeft:'12px', borderLeft:'2px solid #c0392b' },
  table:        { width:'100%', borderCollapse:'collapse', marginBottom:'20px', fontSize:'0.92rem' },
  th:           { background:'#c0392b', color:'#fff', padding:'10px 14px', textAlign:'left', fontWeight:'700', fontSize:'0.9rem' },
  tdE:          { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff5f5' },
  tdO:          { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff' },
  tdL:          { fontWeight:'600', color:'#7B0D0D', whiteSpace:'nowrap', width:'220px' },
  code:         { fontFamily:"'Courier New', monospace", fontSize:'0.88rem', whiteSpace:'pre-wrap' },
  dWrap:        { margin:'24px 0', background:'#fffafa', border:'1px solid #f0cece', borderRadius:'8px', padding:'20px' },
  dTitle:       { fontWeight:'700', fontSize:'0.95rem', color:'#7B0D0D', marginBottom:'12px', textAlign:'center', letterSpacing:'0.02em' },
  dCaption:     { fontSize:'0.84rem', color:'#555', textAlign:'center', marginTop:'10px', fontStyle:'italic' },
};

function InfoBox({ title, items }) {
  return (
    <div style={S.infoBox}>
      <div style={S.infoBoxTitle}>{title}</div>
      {items.map((item, i) => <div key={i} style={S.infoBoxItem}>{item}</div>)}
    </div>
  );
}

function Table2({ rows }) {
  return (
    <table style={S.table}>
      <thead><tr>
        <th style={{ ...S.th, width:'220px' }}>Concept</th>
        <th style={S.th}>Explanation / Formula</th>
      </tr></thead>
      <tbody>
        {rows.map(([label, content], i) => (
          <tr key={i}>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.tdL }}>{label}</td>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.code }}>{content}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

const RED    = '#c0392b';
const DKRED  = '#7B0D0D';
const BLUE   = '#2E75B6';
const ORANGE = '#e07b00';
const GREEN  = '#27ae60';
const PURPLE = '#8e44ad';
const TEAL   = '#16a085';
const LTRED  = '#fff5f5';
const LTBLU  = '#eaf3ff';
const LTORG  = '#fff7e6';
const LTGRN  = '#f0fef4';
const LTPUR  = '#f5eeff';
const LTTEAL = '#e8faf5';
const BORDER = '#f0cece';

function Defs() {
  return (
    <defs>
      <marker id="aRed"    markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill={RED}/></marker>
      <marker id="aBlue"   markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill={BLUE}/></marker>
      <marker id="aOrange" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill={ORANGE}/></marker>
      <marker id="aGreen"  markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill={GREEN}/></marker>
      <marker id="aPurple" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill={PURPLE}/></marker>
      <marker id="aTeal"   markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill={TEAL}/></marker>
      <marker id="aGray"   markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill="#888"/></marker>
    </defs>
  );
}

function Blk({ x, y, w, h, fill, stroke, label, sub, fs=12 }) {
  return (
    <g>
      <rect x={x} y={y} width={w} height={h} rx={5} fill={fill} stroke={stroke} strokeWidth="1.5"/>
      <text x={x+w/2} y={y+h/2+(sub?-5:5)} textAnchor="middle" fontSize={fs} fill={stroke} fontWeight="700">{label}</text>
      {sub && <text x={x+w/2} y={y+h/2+11} textAnchor="middle" fontSize="9" fill={stroke} opacity="0.85">{sub}</text>}
    </g>
  );
}

function Arr({ x1, y1, x2, y2, color=RED, marker='aRed', dash=false, lbl='', lx, ly }) {
  return (
    <g>
      <line x1={x1} y1={y1} x2={x2} y2={y2} stroke={color} strokeWidth="1.8"
        strokeDasharray={dash ? '5 3' : 'none'} markerEnd={'url(#' + marker + ')'}/>
      {lbl && (
        <text x={lx || ((x1+x2)/2)} y={ly || ((y1+y2)/2 - 5)}
          textAnchor="middle" fontSize="10" fill={color} fontWeight="600">{lbl}</text>
      )}
    </g>
  );
}

function Card({ x, y, w, h, bg, bc, lines }) {
  return (
    <g>
      <rect x={x} y={y} width={w} height={h} rx={3} fill={bg} stroke={bc} strokeWidth="1"/>
      {lines.map((t, i) => (
        <text key={i} x={x+8} y={y+16+i*15}
          fontSize={i===0 ? '11' : '10'} fill={i===0 ? bc : '#444'} fontWeight={i===0 ? '700' : '400'}>{t}</text>
      ))}
    </g>
  );
}

// =================================================================
// Diagram 1 -- Receding Horizon concept (the key MPC idea)
// =================================================================
function DiagramRecedingHorizon() {
  const W = 900, H = 400;
  const bx = 50, by = 30, bw = 840, bh = 300;
  const N = 8, Nc = 4;
  const tScale = bw / 12;
  const toX = t => bx + t * tScale;
  const toY = v => by + bh - v * bh * 0.55;

  // Reference trajectory (step to 1)
  const ref = t => t >= 0 ? 1.0 : 0;

  // Three "snapshots" of the MPC at different times
  const snapshots = [
    {
      t0: 0, color: BLUE,
      pred: [0, 0.25, 0.52, 0.72, 0.87, 0.94, 0.98, 1.0, 1.0],
      applied: [0, 0.25],
    },
    {
      t0: 2, color: ORANGE,
      pred: [0.25, 0.5, 0.73, 0.88, 0.95, 0.98, 1.0, 1.0],
      applied: [0.25, 0.5],
    },
    {
      t0: 4, color: PURPLE,
      pred: [0.5, 0.73, 0.88, 0.96, 0.99, 1.0, 1.0, 1.0],
      applied: [0.5, 0.73],
    },
  ];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Receding Horizon Principle -- Solve, Apply First Step, Shift, Repeat</div>
      <svg viewBox={'0 0 ' + W + ' ' + H} style={{ width:'100%', display:'block' }}>
        <Defs/>
        <rect x={bx} y={by} width={bw} height={bh} rx={4} fill="#fff" stroke={BORDER}/>

        {/* Grid */}
        {[0, 0.25, 0.5, 0.75, 1.0, 1.25].map(v => (
          <g key={'hg'+v}>
            <line x1={bx} y1={toY(v)} x2={bx+bw} y2={toY(v)} stroke="#f5f0f0" strokeWidth="1"/>
            <text x={bx-5} y={toY(v)+4} textAnchor="end" fontSize="9" fill="#ccc">{v.toFixed(2)}</text>
          </g>
        ))}
        {Array.from({length:13}, (_,k) => (
          <g key={'vg'+k}>
            <line x1={toX(k)} y1={by} x2={toX(k)} y2={by+bh} stroke="#f5f0f0" strokeWidth="1"/>
            <text x={toX(k)} y={by+bh+14} textAnchor="middle" fontSize="9" fill="#bbb">{k}</text>
          </g>
        ))}

        {/* Reference line */}
        <line x1={toX(1)} y1={toY(1)} x2={bx+bw} y2={toY(1)} stroke="#bbb" strokeWidth="1.5" strokeDasharray="5 3"/>
        <text x={bx+bw-4} y={toY(1)-5} textAnchor="end" fontSize="10" fill="#888">reference r=1</text>

        {/* Snapshot prediction horizons + applied inputs */}
        {snapshots.map(({ t0, color, pred, applied }) => {
          const Np = pred.length;
          // Prediction trajectory (dashed)
          const predPts = pred.map((v, k) => toX(t0+k) + ',' + toY(v)).join(' ');
          // Applied segment (solid, thicker)
          const appPts = applied.map((v, k) => toX(t0+k) + ',' + toY(v)).join(' ');

          return (
            <g key={t0}>
              {/* Horizon bracket */}
              <rect x={toX(t0)} y={by+4} width={toX(t0+Np-1)-toX(t0)} height={bh-8}
                fill={color} opacity="0.04" rx={2}/>
              <line x1={toX(t0)} y1={by+4} x2={toX(t0)} y2={by+bh-4} stroke={color} strokeWidth="1.5" strokeDasharray="3 2" opacity="0.5"/>
              <line x1={toX(t0+Np-1)} y1={by+4} x2={toX(t0+Np-1)} y2={by+bh-4} stroke={color} strokeWidth="1" strokeDasharray="2 2" opacity="0.4"/>

              {/* Prediction (dashed) */}
              <polyline points={predPts} fill="none" stroke={color} strokeWidth="1.5" strokeDasharray="5 3" opacity="0.8"/>

              {/* Applied (solid) */}
              <polyline points={appPts} fill="none" stroke={color} strokeWidth="3"/>

              {/* Horizon label */}
              <text x={toX(t0+2)} y={by+22} textAnchor="middle" fontSize="9" fill={color} fontWeight="700">
                t={t0}: solve N={Np-1}
              </text>

              {/* Current point */}
              <circle cx={toX(t0)} cy={toY(pred[0])} r={5} fill={color}/>
            </g>
          );
        })}

        {/* Time axis */}
        <line x1={bx} y1={by+bh} x2={bx+bw} y2={by+bh} stroke="#aaa" strokeWidth="1.3"/>
        <line x1={bx} y1={by}    x2={bx}    y2={by+bh} stroke="#aaa" strokeWidth="1.3"/>
        <text x={bx+bw/2} y={by+bh+28} textAnchor="middle" fontSize="11" fill="#777">Time k</text>
        <text x={bx-38} y={by+bh/2} textAnchor="middle" fontSize="11" fill="#777"
          transform={'rotate(-90,' + (bx-38) + ',' + (by+bh/2) + ')'}>Output y(k)</text>

        {/* Legend */}
        <rect x={bx+bw-320} y={by+bh-70} width={314} height={62} rx={4} fill="rgba(255,255,255,0.95)" stroke={BORDER}/>
        <line x1={bx+bw-312} y1={by+bh-52} x2={bx+bw-286} y2={by+bh-52} stroke={BLUE} strokeWidth="2.5"/>
        <text x={bx+bw-282} y={by+bh-48} fontSize="10" fill={BLUE} fontWeight="700">t=0: solve N=8, apply first step only</text>
        <line x1={bx+bw-312} y1={by+bh-34} x2={bx+bw-286} y2={by+bh-34} stroke={ORANGE} strokeWidth="2.5"/>
        <text x={bx+bw-282} y={by+bh-30} fontSize="10" fill={ORANGE} fontWeight="700">t=2: re-solve shifted horizon, apply first</text>
        <line x1={bx+bw-312} y1={by+bh-16} x2={bx+bw-286} y2={by+bh-16} stroke={PURPLE} strokeWidth="2.5"/>
        <text x={bx+bw-282} y={by+bh-12} fontSize="10" fill={PURPLE} fontWeight="700">t=4: re-solve again (receding horizon)</text>
      </svg>
      <div style={S.dCaption}>
        At each time step, MPC solves an open-loop optimisation over a prediction horizon N. Only the first control action is applied; then the horizon shifts one step forward and the problem is solved again with updated state information. The prediction trajectories (dashed) show what the controller plans; the solid segments show what is actually applied. This receding-horizon principle is what gives MPC its feedback properties despite being an open-loop optimisation.
      </div>
    </div>
  );
}

// =================================================================
// Diagram 2 -- MPC Block Diagram
// =================================================================
function DiagramBlockDiagram() {
  const W = 900, H = 340;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>MPC Control Loop -- Optimiser, Plant Model, and State Estimator</div>
      <svg viewBox={'0 0 ' + W + ' ' + H} style={{ width:'100%', display:'block' }}>
        <Defs/>

        {/* Reference / setpoint */}
        <Arr x1={14} y1={100} x2={50} y2={100} color={RED} marker="aRed"/>
        <text x={8} y={94} fontSize="12" fill={RED} fontWeight="700">r</text>
        <text x={8} y={107} fontSize="9" fill="#888">setpoint</text>

        {/* MPC Optimiser (big central block) */}
        <rect x={50} y={52} width={240} height={120} rx={6} fill={LTBLU} stroke={BLUE} strokeWidth="2"/>
        <text x={170} y={82} textAnchor="middle" fontSize="14" fill={BLUE} fontWeight="700">MPC OPTIMISER</text>
        <text x={170} y={98} textAnchor="middle" fontSize="10" fill={BLUE}>min J = sum(||y-r||_Q + ||u||_R)</text>
        <text x={170} y={112} textAnchor="middle" fontSize="10" fill={BLUE}>subject to: model, constraints</text>
        <text x={170} y={126} textAnchor="middle" fontSize="10" fill={BLUE}>Horizon N steps ahead</text>
        <text x={170} y={141} textAnchor="middle" fontSize="9" fill={BLUE} fontStyle="italic">Solve QP at each sample time</text>
        <text x={170} y={154} textAnchor="middle" fontSize="9" fill={BLUE} fontStyle="italic">Apply u*(0|k) only</text>

        {/* Prediction model */}
        <rect x={50} y={196} width={240} height={44} rx={5} fill={LTGRN} stroke={GREEN} strokeWidth="1.5"/>
        <text x={170} y={218} textAnchor="middle" fontSize="11" fill={GREEN} fontWeight="700">PREDICTION MODEL</text>
        <text x={170} y={232} textAnchor="middle" fontSize="9" fill={GREEN}>x(k+j|k) = A*x(k+j-1|k) + B*u(k+j-1|k)</text>

        {/* Arrow: Optimiser uses Model */}
        <line x1={170} y1={172} x2={170} y2={196} stroke={GREEN} strokeWidth="1.5" strokeDasharray="4 2"/>

        {/* u out of optimiser */}
        <Arr x1={290} y1={112} x2={370} y2={112} color={RED} marker="aRed" lbl="u*(0|k)" lx={330} ly={104}/>

        {/* Constraint blocks */}
        <rect x={50} y={258} width={110} height={38} rx={4} fill={LTRED} stroke={RED} strokeWidth="1"/>
        <text x={105} y={275} textAnchor="middle" fontSize="10" fill={RED} fontWeight="700">Input limits</text>
        <text x={105} y={288} textAnchor="middle" fontSize="9" fill={RED}>u_min &lt;= u &lt;= u_max</text>

        <rect x={178} y={258} width={110} height={38} rx={4} fill={LTORG} stroke={ORANGE} strokeWidth="1"/>
        <text x={233} y={275} textAnchor="middle" fontSize="10" fill={ORANGE} fontWeight="700">State limits</text>
        <text x={233} y={288} textAnchor="middle" fontSize="9" fill={ORANGE}>x_min &lt;= x &lt;= x_max</text>

        {/* Plant */}
        <Blk x={370} y={86} w={150} h={52} fill={LTPUR} stroke={PURPLE} label="PLANT" sub="true system (unknown)"/>

        {/* y out of plant */}
        <Arr x1={520} y1={112} x2={620} y2={112} color={PURPLE} marker="aPurple" lbl="y(k)" lx={568} ly={104}/>
        <circle cx={580} cy={112} r={5} fill={PURPLE}/>

        {/* Disturbance d */}
        <Arr x1={445} y1={50} x2={445} y2={86} color={ORANGE} marker="aOrange" dash={true} lbl="d (disturbance)" lx={475} ly={44}/>

        {/* State estimator */}
        <rect x={620} y={78} width={160} height={68} rx={5} fill={LTORG} stroke={ORANGE} strokeWidth="1.5"/>
        <text x={700} y={100} textAnchor="middle" fontSize="11" fill={ORANGE} fontWeight="700">STATE ESTIMATOR</text>
        <text x={700} y={115} textAnchor="middle" fontSize="9" fill={ORANGE}>Kalman filter / observer</text>
        <text x={700} y={128} textAnchor="middle" fontSize="9" fill={ORANGE}>x_hat(k|k) from y(k)</text>

        {/* x_hat back to optimiser */}
        <line x1={700} y1={146} x2={700} y2={220} stroke={ORANGE} strokeWidth="1.8"/>
        <line x1={700} y1={220} x2={170} y2={220} stroke={ORANGE} strokeWidth="1.8"/>
        <Arr x1={170} y1={220} x2={170} y2={196} color={ORANGE} marker="aOrange" lbl="x_hat(k)" lx={240} ly={215}/>

        {/* y also feeds back for output constraint check */}
        <line x1={580} y1={112} x2={580} y2={245} stroke={PURPLE} strokeWidth="1.8"/>
        <Arr x1={580} y1={245} x2={50} y2={245} color={PURPLE} marker="aPurple" lbl="y fed back" lx={316} ly={238}/>

        {/* u also fed to estimator */}
        <line x1={330} y1={112} x2={330} y2={260} stroke={RED} strokeWidth="1.8"/>
        <circle cx={330} cy={112} r={4} fill={RED}/>
        <Arr x1={330} y1={260} x2={620} y2={146} color={RED} marker="aRed" lbl="u(k) fed to estimator" lx={476} ly={200}/>

        {/* Info panel */}
        <rect x={796} y={60} width={94} height={220} rx={4} fill="#fff" stroke={BORDER}/>
        <text x={843} y={76} textAnchor="middle" fontSize="10" fill={DKRED} fontWeight="700">Key</text>
        {[
          {y:84, bg:LTBLU, bc:BLUE,   label:'Optimiser'},
          {y:116,bg:LTGRN, bc:GREEN,  label:'Model'},
          {y:148,bg:LTPUR, bc:PURPLE, label:'Plant'},
          {y:180,bg:LTORG, bc:ORANGE, label:'Estimator'},
          {y:212,bg:LTRED, bc:RED,    label:'Constraints'},
          {y:244,bg:LTRED, bc:RED,    label:'u*(0|k) applied'},
        ].map(({ y, bg, bc, label }) => (
          <g key={y}>
            <rect x={802} y={y} width={82} height={28} rx={3} fill={bg} stroke={bc} strokeWidth="0.8"/>
            <text x={843} y={y+18} textAnchor="middle" fontSize="9" fill={bc} fontWeight="700">{label}</text>
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>
        The MPC loop: at each time step, the optimiser receives the current state estimate x_hat from the estimator, then solves a finite-horizon QP over N steps using the internal prediction model. The optimal first control action u*(0|k) is applied to the plant. The plant output y(k) feeds the estimator to update x_hat. Constraints on u and x are enforced hard (as inequality constraints in the QP) at every step of the horizon.
      </div>
    </div>
  );
}

// =================================================================
// Diagram 3 -- Cost function anatomy
// =================================================================
function DiagramCostFunction() {
  const W = 900, H = 370;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>MPC Cost Function Anatomy -- Tracking, Effort, and Terminal Terms</div>
      <svg viewBox={'0 0 ' + W + ' ' + H} style={{ width:'100%', display:'block' }}>
        <Defs/>

        {/* Big formula */}
        <rect x={10} y={10} width={880} height={60} rx={5} fill={LTBLU} stroke={BLUE} strokeWidth="2"/>
        <text x={450} y={38} textAnchor="middle" fontSize="14" fill={BLUE} fontWeight="700"
          fontFamily="'Courier New',monospace">J = SUM(j=0..N-1) [ (y(k+j)-r)^T Q (y(k+j)-r) + u(k+j)^T R u(k+j) ] + (x(k+N)-x_r)^T Pf (x(k+N)-x_r)</text>
        <text x={450} y={56} textAnchor="middle" fontSize="10" fill="#555">minimised over control sequence U = [u(0|k), u(1|k), ..., u(N-1|k)]</text>

        {/* Three term annotations */}
        {/* Term 1: tracking error */}
        <line x1={200} y1={70} x2={200} y2={100} stroke={RED} strokeWidth="1.5"/>
        <polygon points="200,100 196,92 204,92" fill={RED}/>
        <rect x={10} y={104} width={350} height={92} rx={4} fill={LTRED} stroke={RED} strokeWidth="1.5"/>
        <text x={185} y={122} textAnchor="middle" fontSize="12" fill={RED} fontWeight="700">Stage Tracking Cost</text>
        <text x={18} y={140} fontSize="10" fill="#333" fontFamily="'Courier New',monospace">(y(k+j) - r)^T * Q * (y(k+j) - r)</text>
        <text x={18} y={158} fontSize="10" fill="#444">Q: output weighting matrix (q x q, positive semidefinite)</text>
        <text x={18} y={174} fontSize="10" fill="#444">Penalises deviation from setpoint r at each step</text>
        <text x={18} y={188} fontSize="10" fill={RED}>Large Q = emphasise tracking, may need large u</text>

        {/* Term 2: control effort */}
        <line x1={500} y1={70} x2={500} y2={100} stroke={ORANGE} strokeWidth="1.5"/>
        <polygon points="500,100 496,92 504,92" fill={ORANGE}/>
        <rect x={370} y={104} width={330} height={92} rx={4} fill={LTORG} stroke={ORANGE} strokeWidth="1.5"/>
        <text x={535} y={122} textAnchor="middle" fontSize="12" fill={ORANGE} fontWeight="700">Stage Control Cost</text>
        <text x={378} y={140} fontSize="10" fill="#333" fontFamily="'Courier New',monospace">u(k+j)^T * R * u(k+j)</text>
        <text x={378} y={158} fontSize="10" fill="#444">R: input weighting matrix (p x p, positive definite)</text>
        <text x={378} y={174} fontSize="10" fill="#444">Penalises large control actions (energy, actuator wear)</text>
        <text x={378} y={188} fontSize="10" fill={ORANGE}>Large R = small u, slower response</text>

        {/* Term 3: terminal */}
        <line x1={790} y1={70} x2={790} y2={100} stroke={GREEN} strokeWidth="1.5"/>
        <polygon points="790,100 786,92 794,92" fill={GREEN}/>
        <rect x={714} y={104} width={176} height={92} rx={4} fill={LTGRN} stroke={GREEN} strokeWidth="1.5"/>
        <text x={802} y={122} textAnchor="middle" fontSize="12" fill={GREEN} fontWeight="700">Terminal Cost</text>
        <text x={722} y={140} fontSize="10" fill="#333" fontFamily="'Courier New',monospace">x(k+N)^T * Pf * x(k+N)</text>
        <text x={722} y={158} fontSize="10" fill="#444">P_f: terminal weight (from LQR)</text>
        <text x={722} y={174} fontSize="10" fill="#444">Approximates infinite horizon</text>
        <text x={722} y={188} fontSize="10" fill={GREEN}>Ensures stability (with terminal set)</text>

        {/* Delta u variant */}
        <rect x={10} y={208} width={430} height={76} rx={4} fill={LTPUR} stroke={PURPLE} strokeWidth="1.5"/>
        <text x={225} y={226} textAnchor="middle" fontSize="12" fill={PURPLE} fontWeight="700">Rate-of-Change (Delta-u) Formulation</text>
        <text x={18} y={244} fontSize="10" fill="#333" fontFamily="'Courier New',monospace">J also adds:  sum Delta_u(k+j)^T * S * Delta_u(k+j)</text>
        <text x={18} y={260} fontSize="10" fill="#444">Delta_u = u(j) - u(j-1): penalises sudden changes</text>
        <text x={18} y={274} fontSize="10" fill="#444">Smoother control action; reduces actuator wear</text>

        {/* Slack variables */}
        <rect x={460} y={208} width={430} height={76} rx={4} fill={LTTEAL} stroke={TEAL} strokeWidth="1.5"/>
        <text x={675} y={226} textAnchor="middle" fontSize="12" fill={TEAL} fontWeight="700">Soft Constraints via Slack Variables</text>
        <text x={468} y={244} fontSize="10" fill="#333" fontFamily="'Courier New',monospace">J also adds:  rho * epsilon^2 + rho_inf * ||epsilon||_inf</text>
        <text x={468} y={260} fontSize="10" fill="#444">epsilon: slack variable (violation of soft constraint)</text>
        <text x={468} y={274} fontSize="10" fill="#444">Infeasibility recovery: allows slight violation at high cost</text>

        {/* Horizon tradeoff */}
        <rect x={10} y={296} width={880} height={64} rx={4} fill="#fff" stroke={BORDER}/>
        <text x={450} y={314} textAnchor="middle" fontSize="12" fill={DKRED} fontWeight="700">Horizon Length Trade-off</text>
        {[
          { x:20,  color:BLUE,   label:'Short N (1-5)',   desc:'Fast solve, near-sighted; misses slow dynamics; may be infeasible' },
          { x:230, color:GREEN,  label:'Medium N (10-30)',desc:'Typical industrial; balances cost and computation' },
          { x:490, color:ORANGE, label:'Long N (50-200)', desc:'Better performance, captures slow modes; expensive QP' },
          { x:700, color:PURPLE, label:'N to infinity',   desc:'Approaches LQR (unconstrained); P_f = LQR cost matrix' },
        ].map(({ x, color, label, desc }) => (
          <g key={x}>
            <text x={x+8} y={332} fontSize="10" fill={color} fontWeight="700">{label}:</text>
            <text x={x+8} y={348} fontSize="9.5" fill="#444">{desc}</text>
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>
        The MPC cost J sums three contributions over the prediction horizon: the tracking error (how far outputs are from the setpoint), the control effort (how large the inputs are), and a terminal cost that approximates the infinite-horizon LQR cost to ensure stability. The Q/R trade-off mirrors the LQR design: larger Q emphasises tracking performance, larger R produces smoother and more conservative control actions.
      </div>
    </div>
  );
}

// =================================================================
// Diagram 4 -- Constraint handling visualised
// =================================================================
function DiagramConstraints() {
  const W = 900, H = 380;
  const bx = 50, by = 30, bw = 500, bh = 320;
  const toX = t => bx + (t/10)*bw;
  const toY = v => by + bh - v*bh*0.28;

  // Constrained trajectories
  const uMax = 1.0, uMin = -0.3, yMax = 1.15, yMin = 0;

  const unconstr = Array.from({length:20}, (_,k) => {
    const t = k*10/19;
    return [t, 1 - Math.exp(-1.5*t)*(Math.cos(2*t) + 0.75*Math.sin(2*t))];
  });

  const constr = Array.from({length:20}, (_,k) => {
    const t = k*10/19;
    const unc = 1 - Math.exp(-1.5*t)*(Math.cos(2*t) + 0.75*Math.sin(2*t));
    return [t, Math.min(yMax - 0.005, Math.max(yMin + 0.005, unc * 0.9 + 0.05))];
  });

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Constraint Handling -- Hard vs Soft Constraints on Inputs and States</div>
      <svg viewBox={'0 0 ' + W + ' ' + H} style={{ width:'100%', display:'block' }}>
        <Defs/>
        <rect x={bx} y={by} width={bw} height={bh} rx={4} fill="#fff" stroke={BORDER}/>

        {/* State constraints (y bounds) */}
        <rect x={bx} y={toY(yMax)} width={bw} height={toY(yMin)-toY(yMax)}
          fill={RED} opacity="0.05"/>
        <line x1={bx} y1={toY(yMax)} x2={bx+bw} y2={toY(yMax)} stroke={RED} strokeWidth="1.5" strokeDasharray="5 3"/>
        <line x1={bx} y1={toY(yMin)} x2={bx+bw} y2={toY(yMin)} stroke={RED} strokeWidth="1.5" strokeDasharray="5 3"/>
        <text x={bx+bw-4} y={toY(yMax)-4} textAnchor="end" fontSize="9.5" fill={RED} fontWeight="700">y_max = {yMax.toFixed(2)}</text>
        <text x={bx+bw-4} y={toY(yMin)+14} textAnchor="end" fontSize="9.5" fill={RED} fontWeight="700">y_min = {yMin.toFixed(2)}</text>

        {/* Feasible region shade */}
        <rect x={bx} y={toY(yMax)} width={bw} height={toY(yMin)-toY(yMax)}
          fill={GREEN} opacity="0.06"/>
        <text x={bx+20} y={toY(0.6)} fontSize="10" fill={GREEN} fontWeight="700">FEASIBLE REGION</text>

        {/* Grid */}
        {[0,0.25,0.5,0.75,1.0].map(v => (
          <g key={v}>
            <line x1={bx} y1={toY(v)} x2={bx+bw} y2={toY(v)} stroke="#f5f0f0" strokeWidth="1"/>
            <text x={bx-4} y={toY(v)+4} textAnchor="end" fontSize="9" fill="#ccc">{v.toFixed(2)}</text>
          </g>
        ))}

        {/* Reference */}
        <line x1={bx} y1={toY(1)} x2={bx+bw} y2={toY(1)} stroke="#bbb" strokeWidth="1.5" strokeDasharray="4 4"/>

        {/* Unconstrained response */}
        <polyline points={unconstr.map(([t,v]) => toX(t)+','+toY(v)).join(' ')}
          fill="none" stroke={BLUE} strokeWidth="2" strokeDasharray="6 3" opacity="0.7"/>

        {/* Constrained response */}
        <polyline points={constr.map(([t,v]) => toX(t)+','+toY(v)).join(' ')}
          fill="none" stroke={GREEN} strokeWidth="2.5"/>

        {/* Violation marker */}
        {(() => {
          const vioIdx = unconstr.findIndex(([,v]) => v > yMax);
          if (vioIdx >= 0) {
            const [t, v] = unconstr[vioIdx];
            return (
              <g>
                <circle cx={toX(t)} cy={toY(v)} r={7} fill="none" stroke={RED} strokeWidth="2"/>
                <text x={toX(t)+10} y={toY(v)-5} fontSize="9" fill={RED} fontWeight="700">VIOLATION (without MPC)</text>
              </g>
            );
          }
          return null;
        })()}

        {/* Axes */}
        <line x1={bx} y1={by+bh} x2={bx+bw} y2={by+bh} stroke="#aaa" strokeWidth="1.3"/>
        <line x1={bx} y1={by}    x2={bx}    y2={by+bh} stroke="#aaa" strokeWidth="1.3"/>
        <text x={bx+bw/2} y={by+bh+18} textAnchor="middle" fontSize="11" fill="#777">Time</text>

        {/* Legend */}
        <line x1={bx+10} y1={by+bh-14} x2={bx+40} y2={by+bh-14} stroke={BLUE} strokeWidth="2" strokeDasharray="6 3"/>
        <text x={bx+44} y={by+bh-10} fontSize="10" fill={BLUE}>Unconstrained (violates y_max)</text>
        <line x1={bx+240} y1={by+bh-14} x2={bx+270} y2={by+bh-14} stroke={GREEN} strokeWidth="2.5"/>
        <text x={bx+274} y={by+bh-10} fontSize="10" fill={GREEN}>MPC constrained (respects bounds)</text>

        {/* Right panel */}
        <rect x={570} y={by} width={320} height={bh} rx={5} fill="#fff" stroke={BORDER}/>
        <text x={730} y={by+18} textAnchor="middle" fontSize="12" fill={DKRED} fontWeight="700">Constraint Types</text>

        {[
          { y:by+26, bg:LTRED,  bc:RED,    lines:['Hard input constraints','u_min &lt;= u(k+j) &lt;= u_max','Never violated; QP infeasible if impossible'] },
          { y:by+90, bg:LTORG,  bc:ORANGE, lines:['Rate constraints','Delta_u_min &lt;= u(k+j)-u(k+j-1) &lt;= Delta_u_max','Limits slew rate of actuator'] },
          { y:by+154, bg:LTBLU, bc:BLUE,   lines:['State / output constraints','x_min &lt;= x(k+j) &lt;= x_max','y_min &lt;= y(k+j) &lt;= y_max'] },
          { y:by+218, bg:LTGRN, bc:GREEN,  lines:['Soft constraints (via slack)','Add slack eps to constraint + penalise ||eps||','Prevents infeasibility; violation at high cost'] },
          { y:by+282, bg:LTPUR, bc:PURPLE, lines:['Terminal constraint','x(k+N) in terminal set X_f','Key for stability guarantees'] },
        ].map(({ y, bg, bc, lines }) => (
          <Card key={y} x={576} y={y} w={308} h={60} bg={bg} bc={bc} lines={lines}/>
        ))}
      </svg>
      <div style={S.dCaption}>
        MPC naturally handles both input and state constraints by including them as inequality constraints in the optimisation problem. Without MPC, a standard controller might drive the output above y_max (blue dashed). MPC proactively adjusts u ahead of time, keeping the trajectory within bounds (green solid). Hard constraints are never violated; soft constraints allow small violations at a high penalty cost to maintain feasibility.
      </div>
    </div>
  );
}

// =================================================================
// Diagram 5 -- QP problem structure
// =================================================================
function DiagramQPStructure() {
  const W = 900, H = 350;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>MPC as a Quadratic Program (QP) -- Structure and Solution</div>
      <svg viewBox={'0 0 ' + W + ' ' + H} style={{ width:'100%', display:'block' }}>
        <Defs/>

        {/* Left: QP formulation */}
        <rect x={10} y={10} width={415} height={330} rx={5} fill="#fff" stroke={BORDER}/>
        <rect x={10} y={10} width={415} height={34} rx={5} fill={BLUE} opacity="0.1"/>
        <text x={222} y={33} textAnchor="middle" fontSize="13" fill={BLUE} fontWeight="700">QP Formulation (after condensing)</text>

        <rect x={18} y={52} width={399} height={60} rx={4} fill={LTBLU} stroke={BLUE} strokeWidth="1.5"/>
        <text x={222} y={72} textAnchor="middle" fontSize="12" fill={BLUE} fontWeight="700" fontFamily="'Courier New',monospace">min_U   (1/2) U^T H_qp U + f^T U</text>
        <text x={222} y={90} textAnchor="middle" fontSize="10" fill="#555" fontFamily="'Courier New',monospace">subject to:  A_ineq * U &lt;= b_ineq   (constraints)</text>
        <text x={222} y={104} textAnchor="middle" fontSize="9" fill="#555">U = [u(0|k); u(1|k); ...; u(N-1|k)]  stacked input sequence</text>

        {[
          { y:122, color:RED,    bg:LTRED,  label:'H_qp matrix (Hessian)',
            eq: 'H_qp = B_N^T * (block-diag Q) * B_N + block-diag R',
            note:'H_qp is positive definite (if R > 0); unique minimum' },
          { y:178, color:GREEN,  bg:LTGRN,  label:'f vector (linear term)',
            eq: 'f = B_N^T * (block-diag Q) * (A_N*x_k - R_ref)',
            note:'Depends on current state x_k; updated each step' },
          { y:234, color:ORANGE, bg:LTORG,  label:'A_ineq, b_ineq (constraints)',
            eq: 'Stack input, output, rate constraints across horizon',
            note:'Size: (N*p + N*q) x (N*p); grows linearly with N' },
          { y:290, color:PURPLE, bg:LTPUR,  label:'Prediction matrices A_N, B_N',
            eq: 'A_N: maps x_k to predicted states over N steps',
            note:'B_N: maps U to predicted states; computed offline' },
        ].map(({ y, color, bg, label, eq, note }) => (
          <g key={y}>
            <rect x={18} y={y} width={399} height={52} rx={3} fill={bg} stroke={color} strokeWidth="1"/>
            <text x={26} y={y+15} fontSize="11" fill={color} fontWeight="700">{label}</text>
            <text x={26} y={y+30} fontSize="9.5" fill="#333" fontFamily="'Courier New',monospace">{eq}</text>
            <text x={26} y={y+46} fontSize="9.5" fill="#666">{note}</text>
          </g>
        ))}

        {/* Right: QP solution methods */}
        <rect x={445} y={10} width={445} height={330} rx={5} fill="#fff" stroke={BORDER}/>
        <rect x={445} y={10} width={445} height={34} rx={5} fill={ORANGE} opacity="0.1"/>
        <text x={667} y={33} textAnchor="middle" fontSize="13" fill={ORANGE} fontWeight="700">QP Solvers and Computational Complexity</text>

        {[
          { y:52,  color:BLUE,   bg:LTBLU, lines:['Active Set Methods',
            'Enumerate active constraint sets; move between vertices',
            'Good for warm-starting (solution similar to last step)',
            'Examples: qpOASES, OSQP, HPIPM'] },
          { y:124, color:GREEN,  bg:LTGRN, lines:['Interior Point Methods',
            'Follow central path through feasible interior',
            'Predictable solve time; good for large N',
            'Examples: IPOPT, FORCES Pro'] },
          { y:196, color:ORANGE, bg:LTORG, lines:['Explicit MPC (multiparametric QP)',
            'Pre-solve QP for all possible x_k offline',
            'Online: just evaluate piecewise-affine function',
            'Fastest online; only feasible for small n, N'] },
          { y:268, color:PURPLE, bg:LTPUR, lines:['Complexity scaling',
            'Decision vars: N*p  (N = horizon, p = inputs)',
            'Constraints: O(N*(p+q))  (q = outputs)',
            'Solve time: O((Np)^3) -- must fit sampling period'] },
        ].map(({ y, bg, bc=bg, color, lines }) => (
          <Card key={y} x={453} y={y} w={429} h={68} bg={bg} bc={color} lines={lines}/>
        ))}
      </svg>
      <div style={S.dCaption}>
        After substituting the prediction model into the cost function, MPC reduces to a Quadratic Program (QP): minimise a quadratic objective subject to linear inequality constraints. The Hessian H_qp depends only on system matrices and is computed offline; only the linear term f changes each step (it depends on the current state x_k). Modern QP solvers can solve problems with hundreds of variables in milliseconds, making MPC practical for fast systems.
      </div>
    </div>
  );
}

// =================================================================
// Diagram 6 -- Prediction horizon visualisation with state trajectory
// =================================================================
function DiagramPredictionTrajectory() {
  const W = 900, H = 360;
  const bx = 50, by = 20, bw = 540, bh = 320;
  const N = 10;
  const toX = k => bx + (k / (N + 2)) * bw;
  const toYs = v => by + bh*0.6 - v * bh * 0.25;
  const toYu = v => by + bh*0.9 - v * bh * 0.15;

  // State prediction
  const xPred = [0.3, 0.52, 0.70, 0.83, 0.91, 0.96, 0.98, 0.99, 1.0, 1.0, 1.0];
  // Input sequence
  const uPred = [0.9, 0.75, 0.58, 0.44, 0.34, 0.26, 0.18, 0.12, 0.08, 0.05, 0];
  // Optimal: only first input applied
  const uApp = [0.9];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Prediction Horizon: State Trajectory and Optimal Input Sequence</div>
      <svg viewBox={'0 0 ' + W + ' ' + H} style={{ width:'100%', display:'block' }}>
        <Defs/>
        <rect x={bx} y={by} width={bw} height={bh} rx={4} fill="#fff" stroke={BORDER}/>

        {/* Divider between state and input plot areas */}
        <line x1={bx} y1={by+bh*0.68} x2={bx+bw} y2={by+bh*0.68} stroke="#eee" strokeWidth="1"/>
        <text x={bx+4} y={by+bh*0.68-6} fontSize="9" fill="#aaa" fontStyle="italic">State x(k+j|k)</text>
        <text x={bx+4} y={by+bh*0.68+14} fontSize="9" fill="#aaa" fontStyle="italic">Input u(k+j|k)</text>

        {/* Horizon shading */}
        <rect x={toX(0)} y={by+4} width={toX(N)-toX(0)} height={bh-8} fill={BLUE} opacity="0.03" rx={2}/>
        <rect x={toX(N)} y={by+4} width={toX(N+1.5)-toX(N)} height={bh-8} fill={GREEN} opacity="0.05" rx={2}/>

        {/* State constraint bounds */}
        <line x1={bx} y1={toYs(1.12)} x2={bx+bw} y2={toYs(1.12)} stroke={RED} strokeWidth="1" strokeDasharray="3 2" opacity="0.6"/>
        <text x={bx+bw-4} y={toYs(1.12)-3} textAnchor="end" fontSize="8.5" fill={RED}>x_max</text>

        {/* Input constraint bounds */}
        <line x1={bx} y1={toYu(1.0)} x2={bx+bw} y2={toYu(1.0)} stroke={RED} strokeWidth="1" strokeDasharray="3 2" opacity="0.6"/>
        <text x={bx+bw-4} y={toYu(1.0)-3} textAnchor="end" fontSize="8.5" fill={RED}>u_max</text>
        <line x1={bx} y1={toYu(0)} x2={bx+bw} y2={toYu(0)} stroke={RED} strokeWidth="1" strokeDasharray="3 2" opacity="0.5"/>

        {/* Reference line */}
        <line x1={bx} y1={toYs(1)} x2={bx+bw} y2={toYs(1)} stroke="#bbb" strokeWidth="1.5" strokeDasharray="4 4"/>
        <text x={bx+4} y={toYs(1)-4} fontSize="8.5" fill="#888">r=1</text>

        {/* State prediction trajectory */}
        <polyline points={xPred.map((v,k) => toX(k)+','+toYs(v)).join(' ')}
          fill="none" stroke={BLUE} strokeWidth="2.5"/>
        {xPred.map((v, k) => (
          <circle key={'sp'+k} cx={toX(k)} cy={toYs(v)} r={k===0?6:4}
            fill={k===0?RED:BLUE} opacity={k===0?1:0.8}/>
        ))}

        {/* Input sequence (step plot) */}
        {uPred.map((v, k) => {
          if (k >= N) return null;
          return (
            <g key={'up'+k}>
              <line x1={toX(k)} y1={toYu(v)} x2={toX(k+1)} y2={toYu(v)}
                stroke={k===0?RED:ORANGE} strokeWidth={k===0?3:1.8} opacity={k===0?1:0.7}/>
              <line x1={toX(k+1)} y1={toYu(v)} x2={toX(k+1)} y2={toYu(uPred[k+1]||v)}
                stroke={ORANGE} strokeWidth="1.8" opacity="0.7"/>
              <circle cx={toX(k)} cy={toYu(v)} r={k===0?5:3}
                fill={k===0?RED:ORANGE} opacity={k===0?1:0.8}/>
            </g>
          );
        })}

        {/* k=0 marker */}
        <line x1={toX(0)} y1={by+4} x2={toX(0)} y2={by+bh-4} stroke={RED} strokeWidth="2" strokeDasharray="4 2" opacity="0.5"/>
        <text x={toX(0)+4} y={by+16} fontSize="10" fill={RED} fontWeight="700">k (now)</text>

        {/* k+N marker */}
        <line x1={toX(N)} y1={by+4} x2={toX(N)} y2={by+bh-4} stroke={GREEN} strokeWidth="1.5" strokeDasharray="4 2" opacity="0.5"/>
        <text x={toX(N)+4} y={by+16} fontSize="10" fill={GREEN} fontWeight="700">k+N (horizon end)</text>

        {/* Terminal cost annotation */}
        <circle cx={toX(N)} cy={toYs(xPred[N])} r={8} fill="none" stroke={GREEN} strokeWidth="2"/>
        <text x={toX(N)+12} y={toYs(xPred[N])-8} fontSize="9" fill={GREEN} fontWeight="700">Terminal cost P_f</text>

        {/* Apply first only */}
        <rect x={toX(0)-2} y={toYu(uPred[0])-4} width={toX(1)-toX(0)+4} height={8} fill={RED} opacity="0.2" rx={2}/>
        <text x={(toX(0)+toX(1))/2} y={toYu(uPred[0])+22} textAnchor="middle" fontSize="9" fill={RED} fontWeight="700">APPLIED</text>

        {/* Axes */}
        <line x1={bx} y1={by+bh} x2={bx+bw} y2={by+bh} stroke="#aaa" strokeWidth="1.3"/>
        <line x1={bx} y1={by}    x2={bx}    y2={by+bh} stroke="#aaa" strokeWidth="1.3"/>
        {Array.from({length:N+2}, (_,k) => (
          <text key={'kt'+k} x={toX(k)} y={by+bh+14} textAnchor="middle" fontSize="9" fill="#bbb">
            {k===0?'k':k===N?'k+N':'k+'+(k)}
          </text>
        ))}

        {/* Right panel */}
        <rect x={608} y={by} width={282} height={bh} rx={5} fill="#fff" stroke={BORDER}/>
        <text x={749} y={by+18} textAnchor="middle" fontSize="12" fill={DKRED} fontWeight="700">Horizon Parameters</text>

        {[
          { y:by+26, bg:LTBLU,  bc:BLUE,   lines:['Prediction horizon N','Number of steps to optimise over','Larger N = better performance, slower solve'] },
          { y:by+90, bg:LTRED,  bc:RED,    lines:['Control horizon Nc','u fixed for j &gt; Nc (u(j) = u(Nc-1))', 'Nc &lt;= N; reduces decision variables'] },
          { y:by+154, bg:LTGRN, bc:GREEN,  lines:['Terminal state x(k+N)','Should reach terminal set X_f','Terminal cost P_f (from infinite-horizon LQR)'] },
          { y:by+218, bg:LTORG, bc:ORANGE, lines:['Sample time T_s','MPC must solve QP within T_s','Fast systems need fast solver or explicit MPC'] },
          { y:by+282, bg:LTPUR, bc:PURPLE, lines:['First input only','Apply u*(0|k) then re-solve','Feedback via new measurement at k+1'] },
        ].map(({ y, bg, bc, lines }) => (
          <Card key={y} x={614} y={y} w={270} h={60} bg={bg} bc={bc} lines={lines}/>
        ))}
      </svg>
      <div style={S.dCaption}>
        The prediction trajectory shows the state evolution x(k+j|k) (blue circles, top) and the optimal input sequence u*(k+j|k) (orange steps, bottom) over the horizon N. Only the first input u*(0|k) (red) is actually applied. The state is predicted to reach the reference by k+N. The terminal cost at k+N (green circle) approximates the cost-to-go beyond the horizon. Separating prediction horizon N from control horizon Nc (u held constant after Nc) reduces computation.
      </div>
    </div>
  );
}

// =================================================================
// Diagram 7 -- MPC vs PID vs LQR comparison
// =================================================================
function DiagramComparison() {
  const W = 900, H = 320;
  const cols = [
    { name:'PID',   color:TEAL,   bg:LTTEAL },
    { name:'LQR',   color:BLUE,   bg:LTBLU  },
    { name:'MPC',   color:RED,    bg:LTRED  },
  ];
  const rows = [
    { attr:'Handles constraints',     pid:'No (saturation only)',      lqr:'No (soft via penalty)',  mpc:'YES - hard constraints built in' },
    { attr:'Optimal cost criterion',  pid:'No (empirical tuning)',      lqr:'YES (quadratic J)',      mpc:'YES (quadratic J, finite N)' },
    { attr:'Multivariable (MIMO)',     pid:'Difficult (decoupling)',     lqr:'YES (natively)',         mpc:'YES (natively)' },
    { attr:'Preview / feed-forward',  pid:'Limited (2DOF)',             lqr:'No (feedback only)',     mpc:'YES (reference preview in J)' },
    { attr:'Explicit constraints',    pid:'No',                         lqr:'No',                     mpc:'YES (input, state, rate)' },
    { attr:'Computational load',      pid:'Very low (arithmetic)',      lqr:'Low (matrix multiply)',  mpc:'High (QP solve each step)' },
    { attr:'Stability guarantee',     pid:'Tuning-dependent',           lqr:'YES (Lyapunov / ARE)',   mpc:'YES (with terminal cost/set)' },
    { attr:'Nonlinear systems',       pid:'Via gain scheduling',        lqr:'Linearise + LQR',        mpc:'NMPC (nonlinear programming)' },
    { attr:'Implementation',          pid:'Very simple',                lqr:'Moderate (need full x)', mpc:'Complex (QP solver required)' },
    { attr:'Industrial use',          pid:'95% of loops',               lqr:'Servo, aerospace',       mpc:'Process, automotive, robotics' },
  ];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>MPC vs PID vs LQR -- Feature Comparison</div>
      <svg viewBox={'0 0 ' + W + ' ' + H} style={{ width:'100%', display:'block' }}>
        <Defs/>

        {/* Header */}
        <rect x={10} y={10} width={200} height={32} fill={DKRED} rx={3}/>
        <text x={110} y={31} textAnchor="middle" fontSize="12" fill="#fff" fontWeight="700">Feature</text>
        {cols.map(({ name, color, bg }, ci) => (
          <g key={name}>
            <rect x={216+ci*226} y={10} width={220} height={32} fill={color} opacity="0.15" stroke={color} strokeWidth="1.5" rx={3}/>
            <text x={326+ci*226} y={31} textAnchor="middle" fontSize="13" fill={color} fontWeight="700">{name}</text>
          </g>
        ))}

        {/* Rows */}
        {rows.map(({ attr, pid, lqr, mpc }, ri) => {
          const bg = ri%2===0 ? '#fafafa' : '#fff';
          const vals = [pid, lqr, mpc];
          return (
            <g key={ri}>
              <rect x={10} y={46+ri*27} width={200} height={27} fill={DKRED} opacity="0.07" stroke="#f0cece" strokeWidth="0.5"/>
              <text x={16} y={64+ri*27} fontSize="10" fill={DKRED} fontWeight="700">{attr}</text>
              {vals.map((val, ci) => {
                const isYes = val.startsWith('YES');
                const isNo  = val.startsWith('No');
                const c = isYes ? cols[ci].color : isNo ? '#aaa' : '#333';
                return (
                  <g key={ci}>
                    <rect x={216+ci*226} y={46+ri*27} width={220} height={27} fill={isYes?cols[ci].bg:bg} stroke="#f0cece" strokeWidth="0.5"/>
                    <text x={222+ci*226} y={64+ri*27} fontSize="9.5" fill={c} fontWeight={isYes?'700':'400'}>{val}</text>
                  </g>
                );
              })}
            </g>
          );
        })}
      </svg>
      <div style={S.dCaption}>
        MPC outperforms PID and LQR in three critical areas: explicit constraint handling (no need for anti-windup or separate saturators), reference preview (future setpoints visible in the cost), and MIMO coupling handled naturally. The trade-off is computational complexity -- a QP must be solved every sampling period. For slow processes (chemicals, HVAC, autonomous vehicles) this is manageable; for very fast systems (microsecond sampling) explicit MPC or simpler controllers are preferred.
      </div>
    </div>
  );
}

// =================================================================
// Diagram 8 -- Stability: terminal set and terminal cost
// =================================================================
function DiagramStability() {
  const W = 900, H = 360;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>MPC Stability -- Terminal Cost, Terminal Set, and Nominal Stability</div>
      <svg viewBox={'0 0 ' + W + ' ' + H} style={{ width:'100%', display:'block' }}>
        <Defs/>

        {/* Left: Lyapunov decrease */}
        <rect x={10} y={10} width={370} height={340} rx={5} fill="#fff" stroke={BORDER}/>
        <text x={195} y={28} textAnchor="middle" fontSize="13" fill={DKRED} fontWeight="700">Why MPC Can Be Unstable Without Care</text>

        {(() => {
          const bx=20, by=38, bw=350, bh=180;
          const toX = k => bx + (k/12)*bw;
          const toY = v => by + bh - v*bh*0.4;

          // Short-sighted MPC: oscillates to ref then diverges
          const badTraj = [0.2, 0.6, 1.1, 0.8, 1.15, 0.7, 1.2, 0.65, 1.25];
          // Good MPC with terminal cost: converges
          const goodTraj = [0.2, 0.55, 0.78, 0.92, 0.98, 1.01, 1.0, 1.0, 1.0];

          return (
            <g>
              <rect x={bx} y={by} width={bw} height={bh} rx={3} fill="#fafafa" stroke="#eee"/>
              <line x1={bx} y1={toY(1)} x2={bx+bw} y2={toY(1)} stroke="#bbb" strokeWidth="1.5" strokeDasharray="4 3"/>
              <text x={bx+bw-4} y={toY(1)-4} textAnchor="end" fontSize="9" fill="#888">r=1</text>

              <polyline points={badTraj.map((v,k) => toX(k)+','+toY(v)).join(' ')}
                fill="none" stroke={RED} strokeWidth="2" strokeDasharray="5 3"/>
              <polyline points={goodTraj.map((v,k) => toX(k)+','+toY(v)).join(' ')}
                fill="none" stroke={GREEN} strokeWidth="2.5"/>

              <line x1={bx} y1={by+bh} x2={bx+bw} y2={by+bh} stroke="#aaa" strokeWidth="1"/>
              <text x={bx+60} y={by+bh+14} fontSize="9" fill={RED}>Short N, no terminal (unstable)</text>
              <text x={bx+200} y={by+bh+14} fontSize="9" fill={GREEN}>With terminal cost (stable)</text>
            </g>
          );
        })()}

        {[
          { y:228, bg:LTRED, bc:RED, lines:['Instability risk','Short N + no terminal: cost can increase k-to-k','MPC "forgets" what happens beyond horizon end'] },
          { y:282, bg:LTGRN, bc:GREEN, lines:['Stability condition (Rawlings-Mayne)','Terminal cost: V_f(x) = x^T P_f x  (LQR cost-to-go)','Terminal set: X_f invariant under LQR u = -Kx'] },
        ].map(({ y, bg, bc, lines }) => (
          <Card key={y} x={18} y={y} w={354} h={50} bg={bg} bc={bc} lines={lines}/>
        ))}

        {/* Right: stability conditions */}
        <rect x={400} y={10} width={490} height={340} rx={5} fill="#fff" stroke={BORDER}/>
        <text x={645} y={28} textAnchor="middle" fontSize="13" fill={DKRED} fontWeight="700">Stability Theorems and Conditions</text>

        {[
          { y:36,  color:GREEN, bg:LTGRN, lines:[
            'Lyapunov stability: V_f as Lyapunov function',
            'If V_f(x) is the infinite-horizon LQR cost-to-go for A-BK,',
            'and X_f is positively invariant under u=-Kx, and X_f in X,',
            'then the MPC closed loop is asymptotically stable.',
          ]},
          { y:108, color:BLUE, bg:LTBLU, lines:[
            'How to compute P_f (LQR cost matrix)',
            'Solve ARE: A^T P_f + P_f A - P_f B R^(-1) B^T P_f + Q = 0',
            'This is identical to LQR design -- P_f is the LQR cost matrix.',
            'MATLAB: P_f = dare(A, B, Q, R)',
          ]},
          { y:180, color:ORANGE, bg:LTORG, lines:[
            'How to compute terminal set X_f',
            'Find largest invariant set of x_dot = (A-BK)x within X,U',
            'Approximation: ellipsoidal set {x : x^T P_f x &lt;= alpha}',
            'alpha chosen so LQR input u=-Kx satisfies u in U for all x in X_f',
          ]},
          { y:252, color:PURPLE, bg:LTPUR, lines:[
            'Practical simplifications',
            'Large N: terminal constraint often inactive; stability likely',
            'No terminal: works in practice if N long enough (not guaranteed)',
            'Feasibility: if X_f non-empty and feasible at k=0, stays feasible',
          ]},
        ].map(({ y, color, bg, lines }) => (
          <Card key={y} x={408} y={y} w={474} h={68} bg={bg} bc={color} lines={lines}/>
        ))}
      </svg>
      <div style={S.dCaption}>
        Without a terminal cost, MPC with a short horizon can be unstable: the controller is short-sighted and may choose actions that look good over N steps but cause problems later. Adding a terminal cost V_f = x^T P_f x (the LQR cost-to-go, computed from the discrete ARE) and restricting x(k+N) to a terminal invariant set X_f provides a rigorous Lyapunov stability proof. In practice, sufficiently long horizons often provide stability even without terminal conditions.
      </div>
    </div>
  );
}

// =================================================================
// Diagram 9 -- Nonlinear MPC and Economic MPC
// =================================================================
function DiagramNMPC() {
  const W = 900, H = 330;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Nonlinear MPC (NMPC) and Economic MPC -- Beyond Linear Quadratic</div>
      <svg viewBox={'0 0 ' + W + ' ' + H} style={{ width:'100%', display:'block' }}>
        <Defs/>

        {/* Left: NMPC */}
        <rect x={10} y={10} width={420} height={310} rx={5} fill="#fff" stroke={BORDER}/>
        <rect x={10} y={10} width={420} height={34} rx={5} fill={RED} opacity="0.1"/>
        <text x={220} y={33} textAnchor="middle" fontSize="13" fill={RED} fontWeight="700">Nonlinear MPC (NMPC)</text>

        <rect x={18} y={52} width={404} height={50} rx={4} fill={LTRED} stroke={RED} strokeWidth="1.5"/>
        <text x={220} y={70} textAnchor="middle" fontSize="11" fill={RED} fontWeight="700" fontFamily="'Courier New',monospace">min J = sum l(x,u) + V_f(x_N)</text>
        <text x={220} y={85} textAnchor="middle" fontSize="10" fill="#555">s.t. x(j+1) = f(x(j), u(j))  [nonlinear model]</text>
        <text x={220} y={98} textAnchor="middle" fontSize="9.5" fill="#555">u in U,  x in X,  x_N in X_f</text>

        {[
          { y:110, color:RED,    bg:LTRED, lines:['Nonlinear prediction model','x(j+1) = f(x(j), u(j)): arbitrary nonlinear ODE','Must integrate numerically (RK4, etc.) over horizon'] },
          { y:162, color:ORANGE, bg:LTORG, lines:['NLP instead of QP','Nonconvex: local optima possible','Solvers: IPOPT, CasADi, ACADO, acados'] },
          { y:214, color:BLUE,   bg:LTBLU, lines:['Real-time iteration (RTI)','One SQP iteration per step (not full solve)','Warm-start from previous solution'] },
          { y:266, color:GREEN,  bg:LTGRN, lines:['Applications','Autonomous vehicles, robots, aircraft','Chemical reactors, batch processes'] },
        ].map(({ y, color, bg, lines }) => (
          <Card key={y} x={18} y={y} w={404} h={46} bg={bg} bc={color} lines={lines}/>
        ))}

        {/* Right: Economic MPC */}
        <rect x={450} y={10} width={440} height={310} rx={5} fill="#fff" stroke={BORDER}/>
        <rect x={450} y={10} width={440} height={34} rx={5} fill={ORANGE} opacity="0.1"/>
        <text x={670} y={33} textAnchor="middle" fontSize="13" fill={ORANGE} fontWeight="700">Economic MPC (EMPC)</text>

        <rect x={458} y={52} width={424} height={50} rx={4} fill={LTORG} stroke={ORANGE} strokeWidth="1.5"/>
        <text x={670} y={70} textAnchor="middle" fontSize="11" fill={ORANGE} fontWeight="700" fontFamily="'Courier New',monospace">min J = sum l_e(x, u)  [any economic cost]</text>
        <text x={670} y={85} textAnchor="middle" fontSize="10" fill="#555">l_e: profit, energy use, throughput, emissions</text>
        <text x={670} y={98} textAnchor="middle" fontSize="9.5" fill="#555">Cost is not a tracking error -- it is an economic objective</text>

        {[
          { y:110, color:ORANGE, bg:LTORG, lines:['Key difference from tracking MPC','No fixed setpoint: optimise raw performance metric','e.g., maximise yield, minimise energy per unit output'] },
          { y:162, color:TEAL,   bg:LTTEAL,lines:['Dissipativity condition (stability)','Requires l_e to satisfy storage function condition','Generalises Lyapunov approach for economic costs'] },
          { y:214, color:PURPLE, bg:LTPUR, lines:['Rotating cost (modified EMPC)','J_rot = sum(l_e - lambda^T*f + lambda^T*x + ...)', 'Adds a "rotation" term to recover stability property'] },
          { y:266, color:GREEN,  bg:LTGRN, lines:['Applications','Power grids: minimise generation cost','Chemical plants: maximise conversion rate','Smart buildings: minimise energy cost'] },
        ].map(({ y, color, bg, lines }) => (
          <Card key={y} x={458} y={y} w={424} h={46} bg={bg} bc={color} lines={lines}/>
        ))}
      </svg>
      <div style={S.dCaption}>
        Nonlinear MPC (NMPC) uses the full nonlinear plant model f(x,u) in the prediction, resulting in a Nonlinear Program (NLP) instead of a QP. Real-time iteration (one SQP step per sample) makes NMPC practical for fast systems. Economic MPC replaces the tracking cost with a direct economic objective (profit, energy, emissions) -- there is no setpoint, just an economic criterion to optimise. Stability requires a dissipativity condition rather than the standard terminal cost approach.
      </div>
    </div>
  );
}

// =================================================================
// Diagram 10 -- Complete MPC design workflow
// =================================================================
function DiagramWorkflow() {
  const W = 900, H = 400;
  const steps = [
    { x:10,  y:20,  w:200, h:76, color:BLUE,   bg:LTBLU,  num:'1',
      title:'Obtain Plant Model',
      lines:['x(k+1) = A*x(k) + B*u(k)', 'y(k) = C*x(k)', 'Linearise if nonlinear'] },
    { x:220, y:20,  w:200, h:76, color:GREEN,  bg:LTGRN,  num:'2',
      title:'Define Cost Weights',
      lines:['Choose Q, R, P_f', 'Q: state/output penalty', 'R: input penalty'] },
    { x:430, y:20,  w:200, h:76, color:ORANGE, bg:LTORG,  num:'3',
      title:'Set Horizon N',
      lines:['N: prediction steps', 'Nc: control horizon', 'T_s: sample time'] },
    { x:640, y:20,  w:250, h:76, color:PURPLE, bg:LTPUR,  num:'4',
      title:'Define Constraints',
      lines:['u_min, u_max, Delta_u_max', 'x_min, x_max (soft or hard)', 'y_min, y_max'] },
    { x:10,  y:180, w:200, h:76, color:RED,    bg:LTRED,  num:'5',
      title:'Compute Prediction Matrices',
      lines:['Build A_N, B_N offline', 'Form H_qp, store for online use', 'H_qp = B_N^T*Q_N*B_N + R_N'] },
    { x:220, y:180, w:200, h:76, color:TEAL,   bg:LTTEAL, num:'6',
      title:'Design State Estimator',
      lines:['Kalman filter or observer', 'Provides x_hat(k|k)', 'Needed if not all states measured'] },
    { x:430, y:180, w:200, h:76, color:BLUE,   bg:LTBLU,  num:'7',
      title:'Solve QP Online',
      lines:['Update f = f(x_hat)', 'Solve: U* = argmin J s.t. constraints', 'Apply u*(0|k) only'] },
    { x:640, y:180, w:250, h:76, color:GREEN,  bg:LTGRN,  num:'8',
      title:'Verify and Tune',
      lines:['Simulate closed-loop response', 'Check constraint satisfaction', 'Adjust Q, R, N if needed'] },
  ];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Complete MPC Design Workflow</div>
      <svg viewBox={'0 0 ' + W + ' ' + H} style={{ width:'100%', display:'block' }}>
        <Defs/>

        {steps.map(({ x, y, w, h, color, bg, num, title, lines }) => (
          <g key={num}>
            <rect x={x} y={y} width={w} height={h} rx={5} fill="#fff" stroke={BORDER}/>
            <rect x={x} y={y} width={w} height={h} rx={5} fill={color} opacity="0.05"/>
            <circle cx={x+18} cy={y+18} r={13} fill={color}/>
            <text x={x+18} y={y+22} textAnchor="middle" fontSize="12" fill="#fff" fontWeight="700">{num}</text>
            <text x={x+36} y={y+15} fontSize="11" fill={color} fontWeight="700">{title}</text>
            {lines.map((t, i) => (
              <text key={i} x={x+10} y={y+32+i*15} fontSize="9.5" fill="#444">{t}</text>
            ))}
          </g>
        ))}

        {/* Row 1 arrows */}
        {[210,420,630].map((x,i) => (
          <Arr key={'r1a'+i} x1={x} y1={58} x2={x+10} y2={58} color="#bbb" marker="aGray"/>
        ))}

        {/* Down from step 4 to row 2 */}
        <Arr x1={765} y1={96} x2={765} y2={136} color="#bbb" marker="aGray"/>
        <line x1={765} y1={136} x2={630} y2={136} stroke="#bbb" strokeWidth="1.5"/>
        <Arr x1={630} y1={136} x2={430} y2={136} color="#bbb" marker="aGray"/>

        {/* Row 2 arrows (right) */}
        {[210,420,640].map((x,i) => (
          <Arr key={'r2a'+i} x1={x} y1={218} x2={x+10} y2={218} color="#bbb" marker="aGray"/>
        ))}

        {/* Iteration arrow */}
        <rect x={10} y={274} width={880} height={116} rx={5} fill="#fff" stroke={BORDER}/>
        <text x={450} y={292} textAnchor="middle" fontSize="12" fill={DKRED} fontWeight="700">Online Loop (runs every sample period T_s)</text>

        {[
          { x:18,  color:ORANGE, label:'Measure/estimate', desc:'Get y(k), compute x_hat(k|k) via Kalman filter or observer' },
          { x:238, color:BLUE,   label:'Update QP',        desc:'Compute f(x_hat); update inequality RHS b_ineq if ref changes' },
          { x:458, color:RED,    label:'Solve QP',         desc:'U* = argmin (1/2)U^T H U + f^T U s.t. A_ineq U &lt;= b_ineq' },
          { x:678, color:GREEN,  label:'Apply + shift',    desc:'Apply u*(0|k); warm-start next QP with shifted solution U*(1:N)' },
        ].map(({ x, color, label, desc }) => (
          <g key={x}>
            <rect x={x} y={300} width={210} height={80} rx={3} fill={color === ORANGE ? LTORG : color === BLUE ? LTBLU : color === RED ? LTRED : LTGRN} stroke={color} strokeWidth="1"/>
            <text x={x+8} y={316} fontSize="10" fill={color} fontWeight="700">{label}</text>
            <text x={x+8} y={332} fontSize="9" fill="#444">{desc}</text>
          </g>
        ))}

        {/* Loop arrows */}
        {[228,448,668].map((x,i) => (
          <Arr key={'la'+i} x1={x} y1={340} x2={x+10} y2={340} color="#bbb" marker="aGray"/>
        ))}
        <path d="M 888 340 Q 900 340 900 390 Q 900 400 450 400 Q 10 400 10 390 Q 10 380 18 380"
          fill="none" stroke="#bbb" strokeWidth="1.5" strokeDasharray="4 2"/>
        <polygon points="18,374 14,382 22,380" fill="#bbb"/>
        <text x={450} y={397} textAnchor="middle" fontSize="9" fill="#888">repeat every T_s</text>
      </svg>
      <div style={S.dCaption}>
        The MPC design workflow splits into two phases. Offline (steps 1-6): derive the model, choose cost weights and horizon, compute the prediction matrices H_qp and B_N, and design the state estimator. Online (step 7, looping): each sample period, update the QP with the current state estimate, solve it, apply the first input, and warm-start the next solve with the shifted solution. Good warm-starting means successive QPs are similar and converge quickly.
      </div>
    </div>
  );
}

// =================================================================
// Main
// =================================================================
export default function ModelPredictiveControl() {
  return (
    <div style={S.wrapper}>
      <h1 style={S.h1}>Model Predictive Control (MPC)</h1>
      <p style={S.p}>
        Model Predictive Control is the dominant advanced control strategy in the process industries and is rapidly expanding into automotive, robotics, and energy systems. Unlike classical controllers that react to the current error, MPC looks ahead: at each sample time it uses an internal model of the plant to predict future behaviour over a finite horizon, solves an optimisation problem to find the best sequence of future control actions, and then applies only the first action before repeating the entire procedure with fresh measurements. This receding horizon approach gives MPC three unique capabilities -- it handles hard constraints on inputs and states directly, it can track time-varying references with preview, and it produces optimal behaviour defined by an explicit cost function.
      </p>

      <InfoBox title="Core Ideas at a Glance" items={[
        "Receding horizon: at each step, solve a finite-horizon OCP over N steps, apply first input, shift and repeat",
        "Prediction: use internal model x(k+j+1|k) = A*x(k+j|k) + B*u(k+j|k) to forecast N steps ahead",
        "Cost function: J = sum of stage costs (||y-r||_Q + ||u||_R) + terminal cost ||x_N||_Pf",
        "Constraints: u_min &lt;= u &lt;= u_max, x_min &lt;= x &lt;= x_max -- enforced at every prediction step",
        "QP formulation: after condensing, MPC = min (1/2)U^T H U + f^T U  s.t.  A_ineq U &lt;= b_ineq",
        "Stability: add terminal cost P_f (LQR cost matrix) and terminal set X_f for rigorous stability",
        "NMPC: replace linear model with nonlinear f(x,u); solve NLP instead of QP",
        "LQG + receding horizon = MPC; LQR is MPC with N to infinity and no constraints",
        "MATLAB: mpc(), nlmpc() in MPC Toolbox; CasADi, acados for custom NMPC",
      ]}/>

      <h2 style={S.h2}>The Receding Horizon Principle</h2>
      <p style={S.p}>
        The defining feature of MPC is the receding (rolling) horizon. At every time step, the controller looks N steps into the future, computes an optimal plan, executes only the immediate first action, then re-plans at the next step with updated state information. The horizon never shrinks -- it always extends N steps ahead, receding as time advances. This gives MPC the benefits of open-loop optimisation (it can plan ahead) while maintaining the feedback properties of closed-loop control (re-planning corrects for model errors and disturbances).
      </p>
      <DiagramRecedingHorizon/>
      <Table2 rows={[
        ["Receding horizon","At time k: optimise over {u(k), u(k+1), ..., u(k+N-1)}\nApply u*(k). At k+1: re-optimise over {u(k+1), ..., u(k+N)}."],
        ["Why recede?","New measurement at each step corrects for model mismatch and disturbances\nFull-horizon open-loop optimal would ignore this feedback"],
        ["Prediction horizon N","Number of future steps over which cost is minimised\nLarger N: better performance, longer-horizon thinking, more computation"],
        ["Control horizon Nc","Often Nc &lt;= N: u held constant at u(Nc) for steps Nc to N-1\nReduces decision variables from N*p to Nc*p without large performance loss"],
        ["Sample time T_s","Must be fast enough to sample the plant dynamics\nQP must solve within T_s; fast systems require fast solvers or explicit MPC"],
        ["Open vs closed loop","MPC is open-loop within each horizon but closed-loop across steps\nDisturbance rejection comes from re-solving, not from the cost function"],
      ]}/>

      <h2 style={S.h2}>MPC Block Diagram</h2>
      <p style={S.p}>
        The MPC control loop has more components than classical feedback: the optimiser at the core solves a constrained optimisation every sample period; the prediction model generates forecasts; the state estimator (Kalman filter or observer) provides the current state x_hat from sensor measurements; and constraints are enforced as inequality conditions in the optimisation. The result is a systematic, model-based controller that unifies estimation, prediction, and optimisation in a single framework.
      </p>
      <DiagramBlockDiagram/>
      <Table2 rows={[
        ["MPC optimiser","Solves: min J over U subject to constraints, using x_hat as initial condition\nOutputs optimal u*(0|k); discards rest of the sequence"],
        ["Prediction model","Internal copy of plant model (linear or nonlinear)\nUsed to predict x(k+j|k) and y(k+j|k) for j=0,...,N-1"],
        ["State estimator","Kalman filter or Luenberger observer: provides x_hat(k|k)\nRequired if not all states are directly measured"],
        ["Constraint representation","Input: u_min &lt;= u(k+j) &lt;= u_max for all j in horizon\nState: x_min &lt;= x(k+j|k) &lt;= x_max for all j"],
        ["Disturbance model","Often augmented with integrating disturbance model d_k\nProvides offset-free tracking even with steady-state plant-model mismatch"],
        ["Offset-free MPC","Augment model: x_aug = [x; d], y_aug = y + d\nKalman filter estimates d; MPC drives y_aug to setpoint r"],
      ]}/>

      <h2 style={S.h2}>Cost Function Anatomy</h2>
      <p style={S.p}>
        The MPC cost function encodes what the designer wants: tracking performance (penalised by Q), control effort (penalised by R), and long-run stability (penalised by the terminal cost P_f). Choosing these weights is the primary design decision in MPC -- analogous to tuning PID gains but with clearer physical meaning and direct connection to performance objectives.
      </p>
      <DiagramCostFunction/>
      <Table2 rows={[
        ["Stage tracking cost","sum_{j=0}^{N-1} (y_{k+j}-r)^T Q (y_{k+j}-r)\nQ positive semidefinite; often Q = C^T C or I; penalises tracking error"],
        ["Stage control cost","sum_{j=0}^{N-1} u_{k+j}^T R u_{k+j}\nR positive definite; penalises input magnitude; ensures H_qp is positive definite"],
        ["Rate-of-change cost","sum Delta_u^T S Delta_u  where Delta_u = u(j)-u(j-1)\nSmooth control action; reduces actuator wear; S typically small"],
        ["Terminal cost","(x_{k+N} - x_r)^T P_f (x_{k+N} - x_r)\nP_f = LQR cost matrix (from discrete ARE); approximates infinite-horizon tail"],
        ["Q/R tuning (Bryson)","Q_ii = 1/(max acceptable y_i deviation)^2\nR_jj = 1/(max acceptable u_j)^2; starting point for iteration"],
        ["Reference preview","r(k+j) can vary with j: the cost penalises future reference too\nMPC naturally handles time-varying setpoints and trajectory tracking"],
      ]}/>

      <h2 style={S.h2}>Constraint Handling</h2>
      <p style={S.p}>
        Constraint handling is arguably the single most important advantage of MPC over all other control methods. Both input constraints (actuator limits, safety bounds) and state constraints (process safety, physical limits) are enforced directly as inequality constraints in the QP at every step of the prediction horizon. No separate anti-windup, saturation logic, or gain scheduling is needed -- the optimiser automatically respects constraints.
      </p>
      <DiagramConstraints/>
      <Table2 rows={[
        ["Hard input constraints","u_min &lt;= u(k+j|k) &lt;= u_max for j = 0,...,N-1\nIncluded as 2*N*p inequality rows in A_ineq; never violated"],
        ["Rate constraints","Delta_u_min &lt;= u(k+j)-u(k+j-1) &lt;= Delta_u_max\nProtects actuators from rapid switching; commonly 10-30% of u range per step"],
        ["State / output constraints","x_min &lt;= A_N*x + B_N*U &lt;= x_max (after substituting prediction)\nBecome linear constraints in U; add 2*N*n rows to A_ineq"],
        ["Feasibility","If constraints are infeasible: QP has no solution\nPrevented by: soft constraints, terminal set, sufficient N"],
        ["Soft constraints","Add slack: x &lt;= x_max + epsilon; penalise epsilon in cost\nAllows small violations at high cost; always feasible"],
        ["Recursive feasibility","If feasible at k, is it feasible at k+1?\nGuaranteed if terminal set X_f is positively invariant and N is long enough"],
      ]}/>

      <h2 style={S.h2}>The Prediction Trajectory</h2>
      <p style={S.p}>
        The prediction trajectory shows the state and input sequences over the horizon that the MPC controller is planning. Understanding this visualisation is key to diagnosing MPC behaviour: if the predicted trajectory hugs a constraint boundary, the constraint is active and driving the solution. If the predicted final state is far from the setpoint, N may be too short.
      </p>
      <DiagramPredictionTrajectory/>
      <Table2 rows={[
        ["State prediction x(k+j|k)","x(k+j|k) = A^j * x(k) + sum_{i=0}^{j-1} A^{j-1-i} B u(k+i|k)\nLinear in x(k) and U; forms the B_N matrix multiplication"],
        ["Condensed form","Substitute prediction into J to eliminate x: results in QP in U only\nCalled 'condensing'; creates dense H_qp but eliminates state variables"],
        ["Sparse form","Keep x as variables too; A_eq enforces dynamics\nSparse H, A: better for interior point solvers; exploits structure"],
        ["Control horizon Nc","u(k+j|k) = u(k+Nc-1|k) for j &gt;= Nc\nReduces QP size from N*p to Nc*p variables"],
        ["Warm starting","Initialise QP solver with shifted previous solution\nu_init(0:N-2) = u_prev(1:N-1); u_init(N-1) = u_prev(N-1)"],
        ["Horizon length guidelines","Rule of thumb: N * T_s should cover the dominant time constant\nFor step reference: N large enough for y to reach setpoint in prediction"],
      ]}/>

      <h2 style={S.h2}>QP Structure and Solvers</h2>
      <p style={S.p}>
        After substituting the prediction model into the cost, MPC becomes a Quadratic Program. The QP structure is highly regular -- the Hessian H_qp is banded and constant (computed offline), only the linear term f changes each step (updated in O(n) time). This structure allows specialised QP solvers to exploit sparsity and warm-starting for very fast solution times.
      </p>
      <DiagramQPStructure/>
      <Table2 rows={[
        ["Decision variable U","U = [u(0|k); u(1|k); ...; u(N-1|k)], size Nc*p x 1\nThe optimisation solves for this vector each step"],
        ["Hessian H_qp","H_qp = B_N^T * blockdiag(Q,...,Q,P_f) * B_N + blockdiag(R,...,R)\nPositive definite (R &gt; 0); constant -- precomputed offline"],
        ["Linear term f","f(x_k) = B_N^T * blockdiag(Q) * (A_N*x_k - R_ref)\nChanges every step; updates in O(N*n) ops"],
        ["Constraint matrix A_ineq","Stacks input, rate, output constraints across horizon\nSize O(N*(p+q)) x N*p; constant -- precomputed offline"],
        ["Active set vs interior point","Active set: fast for warm-starting; exploits small changes between steps\nInterior point: better for long horizons; predictable iterations"],
        ["Explicit MPC","Pre-solve QP parametrically for all x_k; store piecewise-affine map\nOnline: O(1) lookup; feasible only for small n (up to ~4 states)"],
      ]}/>

      <h2 style={S.h2}>MPC vs PID vs LQR</h2>
      <p style={S.p}>
        MPC unifies the best features of classical and modern control while adding constraint handling, which neither PID nor LQR provides natively. The trade-off is computational complexity: solving a QP every sample period requires significantly more computation than PID arithmetic or LQR matrix multiplication. For slow processes (seconds to hours), this is negligible; for fast systems (milliseconds), it requires careful solver selection.
      </p>
      <DiagramComparison/>
      <Table2 rows={[
        ["MPC advantage: constraints","PID and LQR have no systematic constraint handling\nMPC enforces u and x bounds as hard QP inequalities -- the primary benefit"],
        ["MPC advantage: MIMO","PID requires manual decoupling for interacting loops\nMPC handles multi-input multi-output systems natively via matrix cost"],
        ["MPC advantage: preview","Given future reference r(k+j), MPC proactively adjusts u ahead of time\nPID/LQR only react; MPC anticipates"],
        ["LQR connection","LQR = MPC with N to infinity, no constraints, P_f = LQR cost matrix\nUnconstrained MPC converges to LQR as N increases"],
        ["PID connection","PID can be embedded in MPC as constraint or as warm-start\nMPC often used as supervisory layer above PID inner loops"],
        ["Practical choice","Use PID when: no hard constraints, simple SISO, cheap hardware\nUse MPC when: safety-critical constraints, MIMO, slow enough for QP solve"],
      ]}/>

      <h2 style={S.h2}>Stability Theory</h2>
      <p style={S.p}>
        Nominal stability of MPC is not automatic -- it must be designed in. The standard approach uses a terminal cost V_f(x) = x^T P_f x (the LQR cost-to-go from the discrete ARE) and a terminal constraint x(k+N) in X_f (a positively invariant set under the LQR control law). Together, these ensure the MPC cost function acts as a Lyapunov function and the closed-loop system is asymptotically stable.
      </p>
      <DiagramStability/>
      <Table2 rows={[
        ["Lyapunov approach","V_f(x) is the LQR cost-to-go; it decreases along MPC trajectories\nV_f(x(k+1)) - V_f(x(k)) &lt;= -l(x,u) ensures stability"],
        ["Terminal set X_f","Largest positively invariant set of (A-BK) contained in the constraint set\nApproximation: ellipsoidal {x: x^T P_f x &lt;= c} for some c"],
        ["P_f computation","P_f = solution to discrete-time ARE: P = A^T P A - A^T P B (B^T P B + R)^(-1) B^T P A + Q\nSame P as LQR -- MATLAB: P_f = dare(A, B, Q, R)"],
        ["Feasibility and stability","If feasible at k and x(k+N) in X_f, then feasible at k+1 (recursive feasibility)\nStability: V_N(x(k+1)) &lt;= V_N(x(k)) - l(x(k),u*(k))"],
        ["Long-horizon practical stability","If N is large: terminal constraint often inactive; stability likely in practice\nBut no formal guarantee without terminal cost/set"],
        ["Offset-free tracking","Augment model with disturbance state d; Kalman filter estimates d\nMPC drives output to setpoint despite constant disturbances"],
      ]}/>

      <h2 style={S.h2}>Nonlinear MPC and Economic MPC</h2>
      <p style={S.p}>
        When the plant is significantly nonlinear, the linear prediction model becomes inaccurate and MPC performance degrades. Nonlinear MPC (NMPC) uses the full nonlinear model in the prediction, converting the problem to a Nonlinear Program (NLP). Economic MPC (EMPC) further generalises the cost function from a tracking objective to any economic criterion -- profit, energy, throughput -- allowing the controller to directly optimise operational performance rather than deviation from a setpoint.
      </p>
      <DiagramNMPC/>
      <Table2 rows={[
        ["NMPC problem","min J = sum l(x,u) + V_f(x_N) s.t. x(j+1)=f(x(j),u(j)), u in U, x in X\nNonlinear program (NLP): potentially non-convex, local optima possible"],
        ["Real-time iteration","One SQP step per time step (sequential quadratic programming)\nWarm-start from previous solution; accurate enough for stability"],
        ["CasADi / acados","Symbolic differentiation for Jacobians/Hessians automatically\nacados: real-time NMPC solver, ms-level for moderate n"],
        ["Moving horizon estimation","Nonlinear state estimation as dual NMPC: min sum estimation error over horizon\nMore accurate than EKF for highly nonlinear systems"],
        ["EMPC cost","l_e(x,u): not ||y-r||^2 but a direct economic objective\nE.g., profit rate, energy consumed, throughput, emissions"],
        ["EMPC stability","Requires dissipativity: l_e(x,u) - l_e(x_s, u_s) &gt;= -lambda*f(x,u) + lambda*x\nMore restrictive than tracking; not automatic for arbitrary l_e"],
      ]}/>

      <h2 style={S.h2}>Complete Design Workflow</h2>
      <p style={S.p}>
        An MPC design proceeds in two phases. The offline phase derives the model, selects cost weights and horizon, computes the constant parts of the QP (H_qp, A_ineq), and designs the state estimator. The online phase runs every sample period: update the QP linear term f with the current state estimate, solve the QP, apply the first input, and warm-start the next solve. Getting the offline-online split right is essential for real-time implementation.
      </p>
      <DiagramWorkflow/>
      <Table2 rows={[
        ["Step 1: Model","Linearise at operating point if nonlinear; discretise with T_s (ZOH)\nA_d = expm(A*T_s), B_d = integral(expm(A*t)*B, 0, T_s)"],
        ["Step 2: Weights","Q and R as in LQR; P_f from dare(A,B,Q,R)\nStart with Bryson's rule; tune by simulation"],
        ["Step 3: Horizon","N*T_s >= dominant time constant; Nc = N/2 typically\nCheck that QP solve time << T_s on target hardware"],
        ["Step 4: Constraints","Hard: actuator limits (always), rate limits (if needed)\nSoft: output constraints (prevent infeasibility); large penalty rho"],
        ["Steps 5-6: Offline","Build A_N, B_N; form H_qp, A_ineq offline\nDesign Kalman filter with Q_w, R_v matching expected noise"],
        ["Steps 7-8: Online+tune","Update f each step: O(N*n); solve QP: O((N*p)^3)\nSimulate with disturbances; verify feasibility and constraint satisfaction"],
      ]}/>

      <InfoBox title="Key Formulae Summary" items={[
        "Prediction: x(k+j+1|k) = A*x(k+j|k) + B*u(k+j|k), condensed to X = A_N*x + B_N*U",
        "Cost: J = (1/2)U^T H_qp U + f^T U + const,  H_qp = B_N^T Q_N B_N + R_N (constant)",
        "Constraints: A_ineq * U &lt;= b_ineq  (stacked input, output, rate constraints)",
        "Kalman gain: f(x_k) = B_N^T Q_N (A_N x_k - R_ref)  (updates each step, O(Nn) cost)",
        "Terminal cost: P_f from dare(A, B, Q, R)  --  LQR cost-to-go approximates infinite horizon",
        "NMPC: replace A*x+B*u with f(x,u); solve NLP; use real-time iteration for speed",
        "MATLAB: sys = ss(A,B,C,D,Ts); mpc_obj = mpc(sys, Ts, N, Nc); mpc_obj.Weights.OV = Q; mpc_obj.Weights.MV = R",
        "Offset-free: augment model with integrating disturbance; Kalman filter estimates d",
      ]}/>
    </div>
  );
}